<template>
  <div>
    <el-table
      :empty-text="emptyText"
      fixed
      stripe
      :data="campaigns"
      height="350"
      style="width: 100%"
    >
      <el-table-column prop="title" label="Name" :width="selectorTable ? 420 : 320" />
      <el-table-column v-if="!selectorTable" prop="type" label="Type">
        <template slot-scope="scope">
          {{ cleanType(scope.row.type) }}
        </template>
      </el-table-column>
      <el-table-column prop="startDate" label="Start Date" width="150">
        <template slot-scope="scope">
          {{ cleanDate(scope.row.startDate) }}
        </template>
      </el-table-column>
      <el-table-column prop="uniques" label="Uniques">
        <template slot-scope="scope">
          {{ formatNumber(scope.row.uniques) }}
        </template>
      </el-table-column>
      <el-table-column v-if="selectorTable">
        <template width="20" slot-scope="scope">
          <el-checkbox v-model="scope.row.selected" @change="handleChange" />
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { capitalize } from 'lodash';
import { friendlyDate } from '@/helpers/date';
import { formatNumber } from 'accounting';
import collect from 'collect.js';

export default {
  name: 'CampaignFilterTable',
  props: {
    campaigns: {
      type: Array,
      default: () => [],
    },
    emptyText: {
      type: String,
      default: 'No Data',
    },
    selectorTable: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    formatNumber,
    cleanDate(date) {
      return friendlyDate(date, 'en-gb', 'L');
    },
    cleanType(type) {
      return capitalize(type.replace('_', ''));
    },
    handleChange() {
      const selectedCampaigns = collect(this.campaigns)
        .where('selected', true)
        .all();
      this.$emit('change', selectedCampaigns.map(campaign => parseInt(campaign.id, 10)));
    },
  },
  watch: {
    campaigns() {
      this.handleChange();
    },
  },
};
</script>

<style>
#selected-campaigns .el-tabs__nav {
  visibility: hidden !important;
}
</style>



// WEBPACK FOOTER //
// CampaignFilterTable.vue?3c638e21